import React from "react";
import { Phone, MessageCircle } from "lucide-react";
import { SITE } from "../../lib/constants";

/**
 * Sticky bottom CTA bar on mobile only: Call Now + WhatsApp.
 * Replaces individual floating buttons on mobile.
 */
export const MobileStickyCTA = () => {
  return (
    <div
      data-testid="mobile-sticky-cta"
      className="md:hidden fixed bottom-0 left-0 right-0 z-40 px-3 pb-3 pt-2"
      style={{ paddingBottom: "max(0.75rem, env(safe-area-inset-bottom))" }}
    >
      <div className="glass rounded-2xl p-2 flex gap-2 border border-[#D4AF37]/30 shadow-[0_-8px_30px_rgba(0,0,0,0.5)]">
        <a
          href={`tel:${SITE.phone.replace(/\s/g, "")}`}
          data-testid="mobile-cta-call"
          className="flex-1 inline-flex items-center justify-center gap-2 bg-[#D4AF37] hover:bg-[#E6C35C] text-black font-semibold rounded-xl py-3 text-sm transition-colors"
        >
          <Phone className="w-4 h-4" />
          Call Now
        </a>
        <a
          href={SITE.whatsapp}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="mobile-cta-whatsapp"
          className="flex-1 inline-flex items-center justify-center gap-2 bg-[#25D366] hover:bg-[#1ebe57] text-white font-semibold rounded-xl py-3 text-sm transition-colors"
        >
          <MessageCircle className="w-4 h-4" />
          WhatsApp
        </a>
      </div>
    </div>
  );
};
